import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Input, Label, Button } from 'reactstrap'

import { connect } from "react-redux";
import ReactTable from 'react-table';
import FetchStoresListService from '../../../../../../Service/OPSServices/SWInternalServices/FetchStoresListService';
import FetchProductDataService from '../../../../../../Service/OPSServices/SWInternalServices/FetchProductDataService';
function NewTaskProductList(props) {
  const [asins,setAsins]=useState([])
  const [searchText, setSearchText] = useState('');


  const selectedAsinList = (asin) => {
    setAsins(prev => {
      if (prev.includes(asin)) {
        return prev.filter(item => item !== asin); // remove if already selected
      } else {
        return [...prev, asin]; // add if not already selected
      }
    });
  };
  
    const handleStoreWiseProducts=()=>{
      props.setAsinList(asins)
props.setAddProductsPopup(false)
      // console.log(asinList)
    }
    const columns = [
        {
            Header: "Select",
            accessor: "asin",
            width:80,
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                
                <input
                    onChange={() => selectedAsinList(cellInfo.value)}
                    value={cellInfo.value}
                    type="checkbox"
                    name={cellInfo.value}
                    checked={asins && asins.includes(cellInfo.value)}
                  />
              </div>
            ),
          },
          {
            Header: "Parent Asin",
            accessor: "parentProduct",
            width: 110,
            Cell: (cellInfo) => (
              <div className="d-flex justify-content-center w-100">
                <p className='mb-0'>{cellInfo.value}</p>
              </div>
            ),
          },
        {
          Header: "Asin",
          accessor: "asin",
          width: 110,
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-center w-100">
              
              <p className='mb-0'>{cellInfo.value}</p>
            </div>
          ),
        },
        // {
        //   Header: "IsParent",
        //   accessor: "isParentProduct",
        //   Cell: (cellInfo) => (
        //     <div className="d-flex justify-content-center w-100">
        //       <p className='mb-0'>{cellInfo.value ? "Yes" : "No"}</p>
        //     </div>
        //   ),
        // },
        {
          Header: "Product Title",
          accessor: "productTitle",
          Cell: (cellInfo) => (
            <div className="d-flex justify-content-start w-100">
              <p title={cellInfo.value}className='mb-0 comment-paragraph-ticket-history'>{cellInfo.value}</p>
            </div>
          ),
        },
        
         
        ]
   
        const filterProductData = props.productList && props.productList.filter((row) => {
          const parentProduct = (row.parentProduct || '').toLowerCase();
          const isParentProduct = row.isParentProduct ? 'yes' : 'no';
          const productTitle = (row.productTitle || '').toString().toLowerCase();
          const asin = (row.asin || '').toString().toLowerCase();
          return (
            isParentProduct.includes(searchText.toLowerCase()) ||
            parentProduct.includes(searchText.toLowerCase())||
            asin.includes(searchText.toLowerCase())||
            productTitle.includes(searchText.toLowerCase())
          );
        });      
    
  return (
   <>
     <Card className='curve-popup p-3'>
          <Row>
              {/* <Col md={6}>
              <h5 className='mt-2'><b>Add Products :</b></h5></Col> */}
              <Col md={12}>
                <Input
                  className="mb-2 w-50"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  placeholder="Search product by Title and ASIN "
                />
              </Col>
            <Col md={12}>
            <ReactTable
                      data={filterProductData}
                      columns={columns}
                      className="-fixed -highlight -striped mt-2"
                      getTheadProps={() => ({
                        style: {
                          overflowY: "hidden",
                          background: "#B1FA63",
                          color: "#243837",
                        },
                      })}
                      getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.original && rowInfo.original.isParentProduct) {
                          return {
                            style: {
                              backgroundColor: '#dfd7ff', 
                            },
                          };
                        }
                        return {};
                      }}
                      defaultPageSize={5}
                      noDataText={"No Data Found."}
                    />
            </Col>
          
            <Col className="d-flex justify-content-center mt-2">
              <Button
                className="btn-background-color"
                // disabled={selectedStoreData.integerId && emailRecipient ? false : true}
                onClick={() => handleStoreWiseProducts()}
                >
                Done
              </Button>
            </Col>
          </Row>
        </Card>
   </>
  )
}

const mapStateToProps = (state) => {
    return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
      error: state.loggedUser.error,
  
    };
  };
  
  export default connect(mapStateToProps)(NewTaskProductList);